module.exports = __webpack_public_path__ + "img/nbus_box_3-3.5edc4dcd.jpg";